import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { LoadingCard } from './loading-card';
export var Loading = function () { return (_jsxs("div", { className: styles['cards-container'], children: [_jsx(LoadingCard, {}), _jsx(LoadingCard, {}), _jsx(LoadingCard, {}), _jsx(LoadingCard, {})] })); };
